export const ESTATUS = {
  APROBADO: "APROBADO",
  RECHAZADO: "RECHAZADO",
  PENDIENTE_REVISION: "PENDIENTE_REVISION",
};
